import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoBackgroundComponent } from 'src/app/shared/ui-common/video-background/video-background.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/shared/data/shared.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ButtonComponent } from 'src/app/shared/ui-common/button/button.component';

@Component({
  selector: 'app-feature-email-change-verification',
  imports: [CommonModule, VideoBackgroundComponent, ButtonComponent],
  templateUrl: './feature-email-change-verification.component.html',
  styleUrl: './feature-email-change-verification.component.scss',
})
export class FeatureEmailChangeVerificationComponent implements OnInit {
  text = 'Loading';
  error = null;
  succes = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    const token = this.activatedRoute.snapshot.paramMap.get('token') ?? '';

    if (!token) {
      this.router.navigate(['/login']);

      return;
    }

    this.sharedService
      .confirmEmailChange(token)
      .then((response) => {
        this.text = '';
        this.succes = response.content;
      })
      .catch((errorResponse: HttpErrorResponse) => {
        this.text = 'Ooops';
        this.error = errorResponse.error.content;
      });
  }

  onNavigateHome(): void {
    this.router.navigate(['/login']);
  }
}
